const minimization = (measures, value, measure) => {
    let it = measures.findIndex(measureInfo => measureInfo.name === measure)
    if (it < 0) {
        return {
            value, measure
        }
    }

    let curValue = value
    let curMeasureInfo = measures[it]
    let nextMeasureInfo = measures[it + 1]
    while (nextMeasureInfo && curValue >= nextMeasureInfo.size) {
        it += 1;
        curValue = curValue / nextMeasureInfo.size;
        curMeasureInfo = nextMeasureInfo;
        nextMeasureInfo = measures[it + 1];
    }
    return {
        value: curValue, measure: curMeasureInfo.name
    }
}

export default minimization;
